import { Component } from '@angular/core';

@Component({
  selector: 'app-redirector',
  template: ''
})
export class RedirectorComponent {}
